import React from "react";
import styles from "./tabsInput.module.css";
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'

const Tagsinput_ = ({ id, label, key,required=false, ...tagInputArgs }) => {
    return (
        <div className={`${styles.formGroup} ${tagInputArgs?.formGroupClassOverride}`} style={tagInputArgs.formGroupStyleOverride } key={key}>
            {label&&<label style={tagInputArgs.labelStyleOverride } htmlFor={id}>{label} {required&&<span className="required">*</span>}</label>}
            <TagsInput
                 required
                {...tagInputArgs}
                className={styles.input}
                style={tagInputArgs.inputStyleOverride}
            />
         </div>
    );
};

export default React.memo(Tagsinput_);
